export const ADD_PDP_CORRELATED_PRODUCT = 'ADD_PDP_CORRELATED_PRODUCT'
export const TOGGLE_ROX_PANEL = 'TOGGLE_ROX_PANEL'
export const SET_RXC_SCRIPTS_STATUS = 'SET_RXC_SCRIPTS_STATUS'
export const UPDATE_FIND_IN_STORE_MODAL = 'UPDATE_FIND_IN_STORE_MODAL'
export const UPDATE_FIND_IN_STORE_SELECTED_STORE = 'UPDATE_FIND_IN_STORE_SELECTED_STORE'
export const UPDATE_IMAGES_GALLERY = 'UPDATE_IMAGES_GALLERY'
export const UPDATE_PDP_CAROUSEL = 'UPDATE_PDP_CAROUSEL'
export const UPDATE_PDP_CAROUSEL_LOADING = 'UPDATE_PDP_CAROUSEL_LOADING'
export const UPDATE_PDP_EYEMED_APPLY_STATUS = 'UPDATE_PDP_EYEMED_APPLY_STATUS'
export const UPDATE_EYEMED_STATE = 'UPDATE_EYEMED_STATE'
export const UPDATE_PDP_PRESCRIPTION_FRAME_CATENTRY = 'UPDATE_PDP_PRESCRIPTION_FRAME_CATENTRY'
export const UPDATE_PDP_PRESCRIPTION_LENS_CATENTRY = 'UPDATE_PDP_PRESCRIPTION_LENS_CATENTRY'
export const UPDATE_PDP_SELECTED_CAT_ENTRY_ID = 'UPDATE_PDP_SELECTED_CAT_ENTRY_ID'
export const UPDATE_PDP_SELECTED_TRY_LENS = 'UPDATE_PDP_SELECTED_TRY_LENS'
export const UPDATE_PRODUCT_APPLY_BENEFITS = 'UPDATE_PRODUCT_APPLY_BENEFITS'
export const UPDATE_PRODUCT_AVAILABILITY = 'UPDATE_PRODUCT_AVAILABILITY'
export const UPDATE_SEARCH_STORE_LIST = 'UPDATE_SEARCH_STORE_LIST'

export const SHOW_MINICART = 'SHOW_MINICART'
export const HIDE_MINICART = 'HIDE_MINICART'

export const UPDATE_PRODUCT_LOADING = 'UPDATE_PRODUCT_LOADING'

export const SHOW_TRY_LENSES_PANEL = 'SHOW_TRY_LENSES_PANEL'
export const HIDE_TRY_LENSES_PANEL = 'HIDE_TRY_LENSES_PANEL'

export const SHOW_NEED_HELP_PANEL = 'SHOW_NEED_HELP_PANEL'
export const HIDE_NEED_HELP_PANEL = 'HIDE_NEED_HELP_PANEL'

export const UPDATE_CMS_DYNAMIC_CONTENT = 'UPDATE_CMS_DYNAMIC_CONTENT'

export const STORE_RXC_LENS = 'STORE_RXC_LENS'
export const UPDATE_BREADCRUMBS = 'UPDATE_BREADCRUMBS'
export const SET_SELECTED_FACE_SHAPE = 'SET_SELECTED_FACE_SHAPE'
export const SET_SIZE_GUIDE_PANEL_TOOGLE = 'SET_SIZE_GUIDE_PANEL_TOOGLE'

export const mutations = {
  // TODO: find a better name
  [UPDATE_PDP_CAROUSEL]: function (state, payload) {
    const { data, tryLens } = payload
    state.carousel = data
    state.selectedTryLens = tryLens
  },
  [UPDATE_PDP_CAROUSEL_LOADING]: function (state, payload) {
    state.carouselIsLoading = payload
  },
  [UPDATE_PDP_SELECTED_TRY_LENS]: function (state, payload) {
    state.selectedTryLens = payload
  },
  [UPDATE_PDP_SELECTED_CAT_ENTRY_ID]: function (state, catEntryId) {
    state.selectedCatEntryId = catEntryId
  },
  [UPDATE_IMAGES_GALLERY]: function (state, payload) {
    const currentProduct = state.correlatedProducts[state.selectedCatEntryId]
    state.correlatedProducts[state.selectedCatEntryId] = {
      ...currentProduct,
      imagesGallery: payload,
    }
  },
  [ADD_PDP_CORRELATED_PRODUCT]: function (state, product) {
    if (Object.keys(state.correlatedProducts).includes(product.catEntryId)) {
      Object.assign(state.correlatedProducts[product.catEntryId], product)
    } else {
      state.correlatedProducts[product.catEntryId] = product
    }

    state.correlatedProducts = { ...state.correlatedProducts }
  },
  [UPDATE_PDP_PRESCRIPTION_LENS_CATENTRY]: function (state, payload) {
    state.selectedRoxOpticLens = payload
  },

  [UPDATE_PRODUCT_AVAILABILITY]: function (state, { catEntryId, availability }) {
    if (Object.keys(state.correlatedProductsAvailability).includes(catEntryId)) {
      Object.assign(state.correlatedProductsAvailability[catEntryId], availability)
    } else {
      state.correlatedProductsAvailability[catEntryId] = availability
    }

    state.correlatedProductsAvailability = { ...state.correlatedProductsAvailability }
  },
  [UPDATE_PDP_EYEMED_APPLY_STATUS]: function (state, status) {
    state.eyeMed.applied = status
  },

  [UPDATE_EYEMED_STATE]: function (state, payload) {
    state.eyeMed = Object.assign({}, state.eyeMed, payload)
  },

  [UPDATE_PRODUCT_APPLY_BENEFITS]: function (state, payload) {
    state.benefits = payload
  },

  [UPDATE_FIND_IN_STORE_MODAL]: function (state, payload) {
    state.findInStore = Object.assign({}, state.findInStore, payload)
  },
  [UPDATE_SEARCH_STORE_LIST]: function (state, payload) {
    state.searchStoreList = payload
  },
  [UPDATE_FIND_IN_STORE_SELECTED_STORE]: function (state, payload) {
    state.findInStoreSelectedStore = payload
  },

  [TOGGLE_ROX_PANEL]: function (state, payload) {
    state.isRoxPanelRendered = payload
  },
  [SET_RXC_SCRIPTS_STATUS]: function (state, payload) {
    state.areRxcScriptsLoaded = payload
  },
  [UPDATE_PDP_PRESCRIPTION_FRAME_CATENTRY]: function (state, payload) {
    state.selectedRoxOpticFrame = payload
  },
  [SHOW_MINICART]: function (state) {
    state.minicartIsVisible = true
  },
  [HIDE_MINICART]: function (state) {
    state.minicartIsVisible = false
  },
  [UPDATE_PRODUCT_LOADING]: function (state, payload) {
    state.productIsLoading = payload
  },
  [SHOW_TRY_LENSES_PANEL]: function (state) {
    state.tryLensesPanelIsVisible = true
  },
  [HIDE_TRY_LENSES_PANEL]: function (state) {
    state.tryLensesPanelIsVisible = false
  },
  [SHOW_NEED_HELP_PANEL]: function (state) {
    state.needHelpPanelIsVisible = true
  },
  [HIDE_NEED_HELP_PANEL]: function (state) {
    state.needHelpPanelIsVisible = false
  },
  [UPDATE_CMS_DYNAMIC_CONTENT]: function (state, payload) {
    state.cmsDynamicContent = payload
  },
  [STORE_RXC_LENS]: function (state, { catEntryId, lens }) {
    state.rxcLenses = {
      ...state.rxcLenses,
      [catEntryId]: lens,
    }
  },
  [UPDATE_BREADCRUMBS]: function (state, payload) {
    state.breadcrumbs = payload
  },
  [SET_SELECTED_FACE_SHAPE]: function (state, payload) {
    state.selectedFaceShapeProduct = payload.selectedFaceShapeProduct
    state.selectedFaceShape = payload.selectedFaceShape
  },
  [SET_SIZE_GUIDE_PANEL_TOOGLE]: function (state, payload) {
    state.sizeGuidePanelToogleStore = payload
  },
}
